import React from 'react';
import moment from "moment/moment";

const WidgetConsignesContentZoom = (props) => {

    const data = props.data;

    return (
        <div className={"consigneZoomOverlay"}>
            <div className={"consigneZoomCard"}>
                <div className={"consigneZoomCardHeader"}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div className={"consigneZoomCardHeaderTagColor"} style={{background: `${data.tag_color ?? null}`}}>
                        </div>
                        <span className={"consigneZoomCardHeaderTagLabel"}>
                            {data.tag_nom}
                        </span>
                    </div>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => props.onClose()}>
                        <path d="M10 10L31.2903 31.2903" stroke="#002335" stroke-width="4" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M10 31.2891L31.2903 9.99874" stroke="#002335" stroke-width="4" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>
                <div>
                    <div className={"consigneZoomCardContentText"} dangerouslySetInnerHTML={{__html: data.content}}/>
                    <div className={"consigneZoomCardContentDate"}>{moment(data.created_at).format('DD MMMM YYYY')}</div>
                </div>

            </div>

        </div>
    );
};

export default WidgetConsignesContentZoom;